import 'src/global.css';

import { useEffect } from 'react';
import { Amplify } from 'aws-amplify';

import { usePathname } from 'src/routes/hooks';

import { themeConfig, ThemeProvider } from 'src/theme';

import { ProgressBar } from 'src/components/progress-bar';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from 'src/auth/context/amplify';
import { getStoredAmplifyConfig } from 'src/auth/context/amplify/config';

import { SnackbarProvider } from './components/snackbar';

type AppProps = {
  children: React.ReactNode;
};

const storedAmplifyConfig = getStoredAmplifyConfig();
if (storedAmplifyConfig) {
  Amplify.configure(storedAmplifyConfig);
}

export default function App({ children }: AppProps) {
  useScrollToTop();

  return (
    <AuthProvider>
      <SnackbarProvider>
        <SettingsProvider defaultSettings={defaultSettings}>
          <ThemeProvider
            noSsr
            defaultMode={themeConfig.defaultMode}
            modeStorageKey={themeConfig.modeStorageKey}
          >
            <ProgressBar />
            <SettingsDrawer defaultSettings={defaultSettings} />
            {children}
          </ThemeProvider>
        </SettingsProvider>
      </SnackbarProvider>
    </AuthProvider>
  );
}

// ----------------------------------------------------------------------
function useScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
